<script setup lang="ts">
const props = defineProps<{
  name: string
  avatarUrl?: string | null
  size?: 'sm' | 'md' | 'lg'
  decorative?: boolean
}>()

function initials(name: string): string {
  const trimmed = name.trim()
  if (!trimmed) return '?'
  return trimmed.slice(0, 2).toUpperCase()
}
</script>

<template>
  <span
    class="player-avatar"
    :class="size ?? 'md'"
    :aria-hidden="decorative ? 'true' : undefined"
  >
    <img
      v-if="avatarUrl"
      :src="avatarUrl"
      :alt="decorative ? '' : props.name"
      loading="lazy"
    />
    <span v-else>{{ initials(props.name) }}</span>
  </span>
</template>
